(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/pages/order-home/components/preview-card.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/pages/order-home/components/preview-card.js');
"use strict";

const {
  useEffect,
  useRef,
  useContext
} = React;
const {
  Image
} = svs.content.image_v2;
const {
  OrderHomeContext
} = svs.ticketsOrderHome.context;
const {
  firstImage,
  secondImage
} = svs.ticketsOrderHome.data.config.orderHome.orderHomeMessage;
const LineBreaks = _ref => {
  let {
    message
  } = _ref;
  if (!message) return '';
  const parts = message.split('\n');
  return parts.slice(0, 12).reduce((acc, part, i) => {
    if (i === parts.length - 1) {
      return [...acc, part];
    }
    return [...acc, part, React.createElement("br", {
      key: "part-".concat(i)
    })];
  }, []);
};
const PreviewCard = () => {
  const {
    firstName,
    lastName
  } = svs.core.userSession.getUser();
  const {
    state
  } = useContext(OrderHomeContext);
  const scalerRef = useRef(null);
  const imgRef = useRef(null);
  const fullName = "".concat(firstName, " ").concat(lastName);
  const animationRef = useRef(null);
  useEffect(() => {
    const resize = () => {
      if (scalerRef.current) {
        const scaleX = imgRef.current.clientWidth / (secondImage === null || secondImage === void 0 ? void 0 : secondImage.width);
        scalerRef.current.style.transform = "scale(".concat(scaleX, ")");
      }
    };
    const lazyOnResize = _.debounce(resize, 10);
    window.addEventListener('resize', lazyOnResize);
    scalerRef.current.style.setProperty('--preview-image-width', "".concat(secondImage === null || secondImage === void 0 ? void 0 : secondImage.width, "px"));
    scalerRef.current.style.setProperty('--preview-image-height', "".concat(secondImage === null || secondImage === void 0 ? void 0 : secondImage.height, "px"));
    resize();
    animationRef.current.classList.add('visible');
    return () => {
      window.removeEventListener('resize', lazyOnResize);
    };
  }, []);
  return React.createElement("div", {
    className: "u-flex u-flex-column u-flex-align-items-center"
  }, React.createElement("div", {
    className: "relative w100 h100"
  }, React.createElement("div", {
    className: "preview-greeting-card-wrapper preview-greeting-card-hidden",
    ref: animationRef
  }, React.createElement("div", {
    className: "preview-img-wrapper-rotate absolute elevation-400"
  }, firstImage && React.createElement(Image, {
    image: firstImage
  })), React.createElement("div", {
    className: "preview-img-wrapper elevation-400",
    ref: imgRef
  }, secondImage && React.createElement(Image, {
    image: secondImage
  })), React.createElement("div", {
    className: "preview-scaler-wrapper absolute",
    ref: scalerRef
  }, React.createElement("div", {
    className: "preview-messages-scaler-wrapper absolute w100 h100 u-top-0"
  }, React.createElement("div", {
    className: "preview-messages-column w100 h100 u-flex u-flex-column u-flex-align-items-center absolute ".concat(state.greetingMessage ? 'js-greeting-exist' : '')
  }, React.createElement("div", {
    className: "preview-personal-greeting-text margin-top-1 w50 absolute u-text-center",
    "data-testid": "preview-personal-greeting-text-testid"
  }, "".concat(state.personalGreeting, "!")), state.greetingMessage && React.createElement("div", {
    className: "preview-personal-message-text break-word absolute u-text-center",
    "data-testid": "preview-personal-message-text-testid"
  }, React.createElement(LineBreaks, {
    message: state.greetingMessage
  })), React.createElement("div", {
    className: "preview-personal-message-from-text w50 break-word absolute u-text-center"
  }, "Fr\xE5n", React.createElement("div", {
    className: "preview-personal-message-from-name bold margin-top-1"
  }, fullName))))))));
};
setGlobal('svs.ticketsOrderHome.orderHome.components.PreviewCard', PreviewCard);

 })(window);